import _ from "lodash";

import createAccountReducers from './reducers/createAccountReducers'
import authenticationReducers from './reducers/authenticationReducers'
import payslipSampleReducers from './reducers/payslipSampleReducers'
import paymentReducers from './reducers/paymentReducers'
import webinarReducers from './reducers/webinarReducers'
import salaryCalculatorReducers from "./reducers/salaryCalculatorReducers";
import videoReducers from "./reducers/videoReducers";
import courseReducers from "./reducers/courseReducers";
import quizReducers from "./reducers/quizReducers";
import adventCalendarReducers from "./reducers/adventCalendarReducers";

import articles from "../content/articles.json";
import blog from "../content/blog.json";
  
const defaultState = {
  authentication: {
    processing: false
  },
  webinars: {
    list: [],
  },
  adventCalendar: {

  },
  quiz: {
    index: 0,
    answers: [],
    questions: [],
    filter: {},
  },
  my: {
    profile: null,
    mfa: {
      setup: {},
    },
    organisations: [],
  },
  createAccount: {
    userCreated: false,
    userUpdated: false,
    acLeadCreated: false,
    demoAccountCreated: false,
  },
  payslipSample: {
    creating: false,
    payslipDownloadLink: null,
  },
  payment: {
    purchaseConfirmationModalOpen: false,
    stripe: {},
    stats: {}
  },
  salaries: {
    earnings: {},
    deductions: {},
    net: 0
  },
  articles,
  blog ,

  courseCertificateDownloading: false,
  courseCompletion: [],
  courses:[
    {
      id: "1ddd7771-79e8-4fca-8ffb-deecd31e2c28",
      preName: 'Get',
      postName: 'Certified',
      name: "Buddy Payroll",
      slug: "buddy-payroll-certified",
      category: "Buddy Application",
      overview: `Want to get the most of your payroll? This course helps you speed up payroll and become a Buddy Certified Payroll user in no time.`,
      description:`

This course takes you through the whole process of generating and calculating payroll.

At the end of the course, we provide a certification to show that you've taken the time to learn all the key payroll processes.

This course will guide you through the data you need to collect from your employees, and how you insert that into the system.

How to insert leave and timesheets, as well as how to import data from punch clocks.

End of year processes such as Cost of Living Adjustments and Carrying leave over to the following year.

And some more advance functionality including, cut-off leave, overtime and pay dates, terminations and mid-month salary change calculations.

Once you complete this course, you should be able to make the most of Buddy's easy-to-use payroll solution.

      `,
      duration: 60, 
      credits: 50,
      price: 50,
      modules: [
          {
            name: "Chapter 1 - Employee Management",
            modules: [
                  {
                      id: "8b5add58-7cbf-4b99-a967-dd51439a95aa",
                      title: `Adding a New Employee to Buddy`,
                      slug: `add-new-employee`,
                      video: "649107254",
                      desc: `How to add new employees`,
                      duration: 7,
                      overview: `

## Adding a New Employee to Buddy, 

A step-by-step process on how to add new employees, with explanation on relevant personal, salary and tax fields.

`
                  },
                  {
                      id:`453c68c4-a326-4ecb-89d1-58e637157b67`,
                      title: `Adding and Applying Grades`,
                      slug: `adding-grades`,
                      video: "649109292",
                      desc: `Guide on how to add a leave adjustment for employees`,
                      duration: 3,
                      overview: `
## Adding and Applying Grades

This lesson explains Grades, how to create them and how to apply them to employees' salaries
`
                  }]
          },
          {
              name: "Chapter 2 - Basic Payroll",
              modules: [
                  {
                      id:`8b96c87c-92e6-45f8-8c77-006e7ec67958`,
                      title: `Running Payroll`,
                      slug: `running-payroll`,
                      video: "647743029",
                      desc: `Fundamentals of running payroll`,
                      duration: 3,
                      overview: `
## Running Payroll

A step-by-step process explaining the Run Payroll page, what you need to do to save payslips with a couple of example, as well as concluding the whole payroll.
`
                  },
                  {
                    id:`2d3c68cf-1871-49ed-bebe-6db9345a1fe4`,
                    title: `Payslips for Casual Employees`,
                    slug: `payslips-for-casual-employees`,
                    video: "647759665",
                    desc: `How to pay casual employees during payroll`,
                    duration: 2,
                    overview: `
## Issuing a Payslip for a Casual Employee

This lesson shows how to pay casual employees during payroll, including paying for contributions.
`,
                },
                {
                  id:`cdfda388-255b-4196-b119-d662d0e09bcc`,
                  title: `Adding Allowances`,
                  slug: `adding-allowances`,
                  video: "649112413",
                  desc: `How to create allowances`,
                  duration: 4,
                  overview: `
## Adding Allowances

This lesson guides you to create allowances and add them to payslips as either recurring or one-time allowances
`,
              },
              {
                id:`59dda053-aac4-4b8f-ac70-08c3aa79d889`,
                title: `Re-Open a Concluded Payroll`,
                slug: `concluded-payroll`,
                video: "649112179",
                desc: `How to open a concluded payroll`,
                duration: 2,
                overview: `
## Re-Open a Concluded Payroll

This lesson shows you how you can re-open a payroll that was already concluded.
`
            },

              ]
          },
          {
            name: "Chapter 3 - Payroll History",
            modules: [
              {
                id:`d67951ff-ee84-4b6e-8290-21f249f0d2be`,
                title: `Payroll and Supplementary Reports`,
                slug: `payroll-and-supplementary-reports`,
                video: "647771095",
                desc: `How to download payroll reports`,
                duration: 2,
                overview: `
## Payroll and Supplementary Reports

This lesson shows you how to download payroll reports in multiple formats as well as other supplementary payroll reports.
`
              },
              {
                id:`a787f357-cd9f-4f62-9187-1ac1f3c82902`,
                title: `Tax Forms and Electronic Lodgement Files`,
                slug: `tax-forms`,
                video: "649108254",
                desc: `How to download tax forms`,
                duration: 2,
                overview: `
## Tax Forms and Electronic Lodgement Files

This lesson shows you how to download the available Tax Forms (FS5s, FS3s and FS7) as well as the end-of-year Electronic Lodgement Files
`
            },
            ]
        },
        {
          name: "Chapter 4 - Additional Setup",
          modules: [
            {
              id:`1cf65102-2647-4834-b208-4830bd336ec0`,
              title: `Inviting Managers and Setting Permissions`,
              slug: `setting-permissions`,
              video: "649111778",
              desc: `How to add managers and permissions`,
              duration: 1,
              overview: `
## Inviting Managers and Setting Permissions

This lesson teaches you how to invite new managers and set their permissions on your company account.
`
            },
            {
              id:`21092bdf-bf1f-4baa-93ae-701578736494`,
              title: `Explaining Department Managers`,
              slug: `department-managers`,
              video: "649108116",
              desc: `Introducing department managers`,
              duration: 1,
              overview: `
## Explaining Department Managers

This lesson explains what Department Managers are and how you can set them up to manage leave requests.
`
            },
            {
              id:`2ed0dc83-ddb0-4855-a970-a28b8e25ac6f`,
              title: `Overtime Rates`,
              slug: `overtime-rates`,
              video: "649107649",
              desc: `Explaining overtime rates`,
              duration: 2,
              overview: `
## Overtime Rates

This lesson covers how you can create new overtime rates, set custom names and their rates.
`
            },
          ]
      },
      {
        name: "Chapter 5 - Leave Management",
        modules: [
          {
            id:`0c3aabf7-a541-481b-bef5-4a2334011d69`,
            title: `Adding a Leave Application`,
            slug: `adding-leave`,
            video: "647779717",
            desc: `How to add leave applications`,
            duration: 2,
            overview: `
## Adding a Leave Application

This lesson shows you how to add simple leave applications for your employees.
`
          },
          {
            id:`39c523fc-4e35-4025-88ec-f79956995540`,
            title: `Editing a Leave Application`,
            slug: `editing-leave`,
            video: "649108600",
            desc: `How to edit leave applications`,
            duration: 2,
            overview: `
## Editing a Leave Application

This lesson explains how you can edit leave requests, including those that have already been processed.
`
          },
          {
            id:`7af1809d-2ca8-4ca0-8d2d-641147d58e36 `,
            title: `Approving or Denying Pending Requests`,
            slug: `approving-leave`,
            video: "649107501",
            desc: `How to approve, deny or edit leave applications`,
            duration: 2,
            overview: `
## Approving or Denying Pending Requests

This lesson shows you how to edit, approve or deny pending leave requests from your employees.
`
          },
          {
            id:`b806eeac-bc2d-4c5d-9280-2923f9fec224`,
            title: `Sick Leave and Related Automated Processes`,
            slug: `sick-leave`,
            video: "649112756",
            desc: `Explaining sick leave and related automated processes`,
            duration: 2,
            overview: `
## Sick Leave and Related Automated Processes

This lesson explains how to add sick leave, and how Buddy processes Sick Leave Benefits and half-pay or unpaid sick.
`
          },
          {
            id:`23080908-67c9-433c-9388-a833d04f0ec9`,
            title: `The Leave Timeline`,
            slug: `leave-timeline`,
            video: "649110492",
            desc: `Accessing and utilising leave timeline`,
            duration: 2,
            overview: `
## The Leave Timeline

This lesson covers how to access and utilise the leave timeline for improved leave management.
`
          },
          {
            id:`67b6bb28-cf40-46a4-9997-b491012062da`,
            title: `Understanding Leave Balances and Reports`,
            slug: `leave-balances`,
            video: "649113207",
            desc: `Explaining leave balances and reports`,
            duration: 3,
            overview: `
## Understanding Leave Balances and Reports

This lesson explains all the details of leave balances and the leave situation report.
`
          },
          {
            id:`bcdbb83d-9fdf-4dd1-812c-867020efcbbd`,
            title: `Making Adjustments to Balances`,
            slug: `adjusting-balances`,
            video: "649109662",
            desc: `How to add or update leave balances`,
            duration: 3,
            overview: `
## Making Adjustments to Balances

This lesson shows how you can add leave adjustments to update leave balances.
`
          },
        ]
    },
    {
      name: "Chapter 6 - End of Year",
      modules: [
        {
          id:`4c8a9bc4-087b-4d0b-bc78-15d01cf2784d`,
          title: `Carrying Leave Over to Next Year`,
          slug: `leave-carry-over`,
          video: "647764474",
          desc: `How to add leave carry over`,
          duration: 1,
          overview: `
## Carrying Leave Over to Next Year

This lesson explains how you can carryover remaining leave for all employees at the end of the year.
`
        },
        {
          id:`a3beab16-b061-41bc-b00c-30914b45bd00`,
          title: `Applying COLA in a New Year`,
          slug: `applying-cola`,
          video: "647828492",
          desc: `How to apply COLA at the beginning of a year`,
          duration: 1,
          overview: `
## Applying COLA in a New Year

This lesson guides you to apply the COLA (Cost of Living Adjustment) at the beginning of a year.
`
        },
      ]
    },
    {
      name: "Chapter 7 - Advanced Payroll",
      modules: [
        {
          id:`0be50eed-0201-4e3e-9af1-44879a669211`,
          title: `Cut-off and Pay Periods`,
          slug: `cut-off-and-pay-periods`,
          video: "649111466",
          desc: `Explaining pay periods and cut-off periods`,
          duration: 2,
          overview: `
## Cut-off and Pay Periods

This lesson explains the pay period dates and the use of cut-off periods.
`
        },
        {
          id:`9d951ce2-ecc6-4b3c-832e-906a8ad37abb`,
          title: `Uploading Allowances in Bulk to Payroll`,
          slug: `bulk-payroll`,
          video: "648016773",
          desc: `How to upload allowances in bulk to payroll`,
          duration: 2,
          overview: `
## Uploading Allowances in Bulk to Payroll

This lesson guides you to upload a list of allowances in bulk by uploading a .csv spreadsheet.
`
        },
        {
          id:`4e344b9f-ceb4-4ad7-9bf2-bfd41dd66160`,
          title: `Issuing Payslip for a New Employee`,
          slug: `payslip-for-new-employee`,
          video: "647759825",
          desc: `Explaining Issuing Payslip for a New Employee`,
          duration: 2,
          overview: `
## Issuing Payslip for a New Employee

This lesson shows you how to issue a payslip for a new employee.
`
        },
        {
          id:`fab8ed30-8872-406a-97a9-72ff0b2c43a0`,
          title: `Termination and Issuing Final Pay`,
          slug: `termination-and-final-pay`,
          video: "647665963",
          desc: `Explaining Termination and Issuing Final Pay`,
          duration: 2,
          overview: `
## Termination and Issuing Final Pay

This lesson explains how you can terminate an employee in Buddy and issue their final payslip.
`
        },
        {
          id:`5e0f7726-b0aa-43c7-8c6a-a4742dcde8f4`,
          title: `Updating a Salary Mid-Period`,
          slug: `updating-salary-mid-period`,
          video: "649110805",
          desc: `Explaining Updating a Salary Mid-Period`,
          duration: 2,
          overview: `
## Updating a Salary Mid-Period

This lesson shows how to update an employee's salary mid-payroll period and how to issue a payslip with multiple rates.
`
        },
      ]
    },
    {
      name: "Chapter 8 - Billing",
      modules: [
        {
          id:`21e1c646-4eac-49dc-adbd-262ef50ec488`,
          title: `Explaining Credits`,
          slug: `explaining-credits`,
          video: "649107947",
          desc: `How to add managers and permissions`,
          duration: 2,
          overview: `
## Explaining Credits

This lesson discusses Buddy's Credits and where you can keep track of them.
`
        },
      ]
    },

      ]
    },
    {
      id: "46589663-1ae9-42e8-b5a9-116075f184ee",
      preName: 'Learn',
      postName: '',
      name: "Basic Payroll (Malta)",
      slug: "basic-payroll-course-malta",
      category: "Malta Payroll",
      overview: `Maltese Payroll, is more than a few calculations. This course provides a great overview for payroll, and gives you the basic tools to be able to handle payroll yourself.`,
      description:`

This course is currently provided on request, with groups of up to 8 students.

In Basic Payroll, we seek to ensure that all attendees obtain sufficient knowledge to be able to understand the various components of payroll.
And are able to successfully run payroll on their own.

Below is a high-level outline of the course:

- Payroll Overview
  - Required Information
  - Employee Documents & Records
  - Government Entities & their roles
- Leave Entitlements
  - Vacation
  - Sick
  - Public Holidays
  - Other Leave Types
  - Pro-rata Entitlements
- Government Bonuses
  - How to calculate
    - Full-Time 
    - Part-Time Pro-rata
- Overview of Work Regulation Orders
  - Where to find them
  - What they contain
- Overtime Rules
  - What the Law Says
  - Commonly accepted exceptions
  - Common Overtime Pitfalls
- Allowances & Pay Items
  - Pre & Post-Tax
  - Benefits Overview
- Income Tax
  - Different Tax Bands
  - Understanding the applicable tax Bands
- Social Security & Maternity Contributions
  - The different classes
  - How employees move across
  - Part-time employees
- Arriving to Net Pay
- FS5 Submissions
- End of Year Submissions
  - FS3
  - FS7
  - Online Filing Basics
- Key Processes to speed up payroll processing

      `,
      duration: 180, 
      credits: 300,
      price: 300,
    },
    {
      id: "a5c38b92-60c0-4a01-83e2-8a2af171914d",
      preName: 'Learn',
      postName: '',
      name: "Advanced Payroll (Malta)",
      slug: "advanced-payroll-course-malta",
      category: "Malta Payroll",
      overview: `This course is for those who already have a basic payroll understanding, and would like to understand the underlying calculations and advanced concepts.`,
      description:`

This course is currently provided on request, with groups of up to 8 students.

After taking the Advanced Payroll course, you should be capable of validating payroll calculations manually, take responsibility of submitting online FSS Documents.
In addition to having an understanding of all the checks and balances you should have in place to ensure accurate payroll.

Below is a high-level outline of the course:

- Payroll Overview
  - Required Information
  - Employee Documents & Records
  - Government Entities & their roles
- Government Bonuses
  - How to calculate
    - Full-Time 
    - Part-Time Pro-rata
- Overview of Work Regulation Orders
  - Where to find them
  - What they contain
- Overtime Rules
  - What the Law Says
  - Commonly accepted exceptions
  - Common Overtime Pitfalls
- Deep Dive into structuring salaries with pay items
  - Tax Implications of Benefits
  - Detailed calculations of: 
    - Class 1 Benefits
    - Class 2 Benefits
    - Class 3 Benefits 
    - Share Options
    - Pension Contributions
- Income Tax
  - Different Tax Bands
  - Understanding the applicable tax Bands
  - Calculating Tax manually with in-class examples
- Social Security & Maternity Contributions
  - The different classes
  - Correctly rounding contributions
- How to Calculate Payroll on Net Pay
  - Reverse engineer a gross pay from a given net
- FS5 Submissions
- End of Year Submissions
  - FS3
  - FS7
  - Online Filing using the Final Settlement System
    - Manually updating an excel submission (Windows Laptop or Virtual Machine Required)

      `,
      duration: 180, 
      credits: 300,
      price: 300,
    }
  ],
  navBarOverride : {
    hide: ["/advent-calendar", '/set/'],
    marketing: ['/uk/early-access', "/is-buddy-for-you", "/start"],
  },
  footerOverride: {
    hide: ["/advent-calendar", '/set/'],
    marketing: ['/uk/early-access', "/is-buddy-for-you", "/start"],
  },
  adventCalendar:{
    notifications:[],
    modal: false
  }
};


const reducer = (state = defaultState, action) => {

  // run each reducer based on the action
  if (action && action.type.indexOf('CREATE_ACCOUNT') == 0){
    return createAccountReducers(state,action)
  }
  if (action && action.type.indexOf('AUTHENTICATION') == 0){
    return authenticationReducers(state,action)
  }
  if (action && action.type.indexOf('PAYSLIP_SAMPLE') == 0){
    return payslipSampleReducers(state,action)
  }
  if (action && action.type.indexOf('PAYMENT') == 0 || action.type.indexOf('PURCHASE') == 0 || action.type.indexOf('STRIPE') == 0){
    return paymentReducers(state,action)
  }
  if (action && action.type.indexOf('WEBINAR') == 0){
    return webinarReducers(state,action)
  }
  if(action && action.type.indexOf('CALCULATION') == 0){
    return salaryCalculatorReducers(state, action)
  }
  if(action && action.type.indexOf('COURSES') == 0){
    return courseReducers(state, action)
  }
  if(action && action.type.indexOf('QUIZ') == 0){
    return quizReducers(state, action)
  }
  if(action && action.type.indexOf('VIDEO') == 0){
    return videoReducers(state, action)
  }
  if(action && action.type.indexOf('ADVENT_CALENDAR') == 0){

    return adventCalendarReducers(state, action)
  }
  return state
};

export default reducer;